import {createAction} from '@reduxjs/toolkit';

export const purgeInstanceScopedState = createAction('app/purgeInstanceScopedState');
